import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Game } from 'src/app/core/models/game.model';
import { GameService } from 'src/app/core/services/game.service';

@Component({
  selector: 'app-game',
  templateUrl: './game.component.html',
  styleUrls: ['./game.component.scss']
})

/**
 * Dashboard Component
 */
export class GameComponent implements OnInit {
  term: any;
  game: Game[];

  addEditMode: any;
  gameFormGroup: FormGroup;

  constructor(private gameService: GameService, private modalService: NgbModal ) {
  }

  // bread crumb items
  breadCrumbItems: Array<{}>;

  async ngOnInit(): Promise<void> {
    this.breadCrumbItems = [{ label: 'Fortune' }, { label: 'Games', active: true }];
    await this.refresh();
  }

  async refresh() {
    this.game = await this.gameService.getAll();
    console.log("Game Get All",)

  }
  
  async onAddNew(modal: unknown) {
    this.addEditMode = "Add";
    this.gameFormGroup = new FormGroup({
      id: new FormControl<string>(''),
      name: new FormControl<string>(''),
      version: new FormControl<string>(''),

    });
    try {
      const results = await this.modalService.open(modal).result;
      console.log('add edit modal returned', {results, gameAddEditFormGroup: this.gameFormGroup.value});
      if(results=="Save click") {
        const newGame = await this.gameService.create(this.gameFormGroup.value);
        if(newGame != null) {
          //TODO mark sucesss
        } else {
          //TODO mark failure
        }
      } else {
        //TODO mark cancel
      }
    } catch (error) {
      //TODO mark error
    }
    await this.refresh();
  }

  async onDelete(id: string) {
    await this.gameService.delete(id);
    await this.refresh();
   
  }

  async onEdit(modal: unknown, original: Game) {
    this.addEditMode = "Edit";
    this.gameFormGroup = new FormGroup({
      id: new FormControl<string>(original.id),
      name: new FormControl<string>(original.name),
      version: new FormControl<string>(original.version),
      

    });
    try {
      const results = await this.modalService.open(modal).result;
      console.log('add edit modal returned', {results, gameFormGroup: this.gameFormGroup.value});
      if(results=="Save click") {
        const newGame = await this.gameService.update(original.id, this.gameFormGroup.value);
        if(newGame != null) {
          //TODO mark sucesss
        } else {
          //TODO mark failure
        }
      } else {
        //TODO mark cancel
      }
    } catch (error) {
      //TODO mark error
    }
    await this.refresh();
    
  }
}
